/**
 * 28 spec スペーシングスケール (8px グリッド)
 *
 * 一次情報: hub/log/28.../03_ui_implementation_spec.md §1.2 / §2.2
 * 移植元: nasu-patient-app-front/src/shared/styles/spacing.ts
 */
export const SPACING_PX = {
  0: 0,
  '0.5': 2,
  1: 4,
  '1.5': 6,
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  8: 32,
  10: 40,
  12: 48,
  16: 64,
  20: 80,
  24: 96,
} as const

/**
 * コンテナ幅と固定 layout 寸法
 *
 * contentMaxWide: mamoru詳細画面(画像左/項目右の左右分割)専用の意図的な例外。
 * 通常ページは contentMax(720px) を使う。判断根拠は
 * hub/log/46_.../work-log/2_20260701_uiux_design_decisions.md 判断3参照。
 */
export const LAYOUT = {
  sidebarWidth: 224,
  contentMax: 720,
  contentMaxWide: '100%',
  topbarHeight: 44,
  sidebarRowHeight: 30,
  sidebarIconBarHeight: 36,
  // IconBar と同値だが別の行なので別名で持つ(02-components/sidebar.md「片方だけ動かせる状態に」)
  sidebarWorkspaceRowHeight: 36,
  blockRowMinHeight: 28,
} as const

export const SPACING = {
  pageOuter: { xs: 2, sm: 3, md: 4 },
  cardPadding: 2.5,
  sectionGap: 3,
  subSectionGap: 2,
  headingMarginTop: 1.5,
  headingMarginBottom: 1,
  inlineGap: 1,
} as const
